var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDiffusers = function SvgDiffusers(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "293.37 320.6 292.94 321.71 293.95 321.71 293.96 320.6 293.37 320.6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.96 320.6 309.95 321.71 316.11 321.71 315.61 320.6 309.96 320.6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.92,321.71H333.64L395.56,460a8,8,0,1,1-14.6,6.54L316.11,321.71H310l-1,159.62a8,8,0,0,1-8,7.95h-.05a8,8,0,0,1-7.95-8.06l1-159.51h-1L236.17,470.58a8,8,0,0,1-14.95-5.7l54.6-143.17H182.16a13,13,0,0,0-13,13V494.06a13,13,0,0,0,13,13H414.92a13,13,0,0,0,13-13V334.71A13,13,0,0,0,414.92,321.71Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.84,475.2a8,8,0,0,0,10.33-4.62l56.77-148.87.42-1.11H276.24l-.42,1.11-54.6,143.17A8,8,0,0,0,225.84,475.2Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.11,321.71,381,466.52a8,8,0,1,0,14.6-6.54L333.64,321.71l-.5-1.11H315.61Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,320.6v1.11l-1,159.51a8,8,0,0,0,7.95,8.06h.05a8,8,0,0,0,8-7.95l1-159.62V320.6Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.76,246.15,383.28,84.81a8,8,0,1,0-14.95-5.7l-57.8,151.57,1-162.22a8,8,0,0,0-7.95-8h-.05a8,8,0,0,0-8,8l-1.05,166L226.81,83.17a8,8,0,0,0-14.6,6.54l70.06,156.44Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,303.36V305h13.87a6,6,0,0,0,6-6V252.15a6,6,0,0,0-6-6H237.25a6,6,0,0,0-6,6V299a6,6,0,0,0,6,6h13.86v-1.64Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.96 320.6 309.96 320.6 315.61 320.6 333.14 320.6 351.96 320.6 351.96 305 351.96 303.36 251.11 303.36 251.11 305 251.11 320.6 276.24 320.6 293.37 320.6 293.96 320.6",
    fill: "#f0592b"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiffusers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diffusers.d2c2f052.svg";
export { ForwardRef as ReactComponent };